import Glider from "./modules/glider.min";
(() => {
  new Glider(document.querySelector(".glider"), {
    // `auto` allows automatic responsive
    // width calculations
    slidesToShow: 1,
    slidesToScroll: 1,

    // should have been named `itemMinWidth`
    // slides grow to fit the container viewport
    // ignored unless `slidesToShow` is set to `auto`
    itemWidth: undefined,

    // if true, slides wont be resized to fit viewport
    // requires `itemWidth` to be set
    // * this may cause fractional slides
    exactWidth: false,

    arrows: {
      prev: ".glider-prev",
      // may also pass element directly
      next: ".glider-next",
    },

    responsive: [
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
})();
